/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import { array, arrayOf, bool, func, shape, string, oneOf } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import config from '../../config';
import routeConfiguration from '../../routeConfiguration';
import {
  LISTING_STATE_PENDING_APPROVAL,
  LISTING_STATE_CLOSED,
  propTypes,
  // LINE_ITEM_NIGHT,
  // LINE_ITEM_DAY,
} from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  // LISTING_PAGE_PARAM_TYPE_DRAFT,
  // LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
  parse,
} from '../../util/urlHelpers';
import { convertMoneyToNumber } from '../../util/currency';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import { strToSlug } from '../../util/seo';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
// import { richText } from '../../util/richText';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import {
  // Page,
  // NamedLink,
  NamedRedirect,
  AvatarLarge,
  // LayoutSingleColumn,
  // LayoutWrapperTopbar,
  // LayoutWrapperMain,
  // LayoutWrapperFooter,
} from '../../components';
import { NotFoundPage } from '../../containers';
import Footer from '../../custom-components/elements/footer/Footer';

import { sendEnquiry, loadData, setInitialValues, fetchAuthorOtherListings } from './ListingPage.duck';
import { fetchMyTestimonials } from '../../custom-ducks/testimonials.duck';
import { fetchMyCredentials } from '../../custom-ducks/credentials.duck';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGraduationCap,
  faQuoteLeft,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import TierBadge from '../../custom-components/elements/TierBadge/TierBadge';
import {
  TIER_META,
  TIERS,
  readPublicBadgeTier,
  MIN_VERIFIED_TESTIMONIALS,
  MIN_VERIFIED_CERTIFICATIONS,
} from '../../util/coachTier';
import { decode } from 'html-entities';
// import SectionImages from './SectionImages';
// import SectionAvatar from './SectionAvatar';
// import SectionHeading from './SectionHeading';
// import SectionDescriptionMaybe from './SectionDescriptionMaybe';
// import SectionFeaturesMaybe from './SectionFeaturesMaybe';
// import SectionReviews from './SectionReviews';
// import SectionHostMaybe from './SectionHostMaybe';
// import SectionRulesMaybe from './SectionRulesMaybe';
import SectionMapMaybe from './SectionMapMaybe';
import css from './ListingPage.css';
import PremiumProfileBio from '../../custom-components/elements/premium-profile-bio/PremiumProfileBio';
import NavBarWrapper from '../../custom-components/wrappers/navbar-wrapper/NavBarWrapper';
import NavBar from '../../custom-components/elements/nav-bar/NavBar';
import ContainerWrapper from '../../custom-components/wrappers/container-wrapper/ContainerWrapper';
import PageWrapper from '../../custom-components/wrappers/page-wrapper/PageWrapper';
import ListingProfileRight from '../../custom-components/elements/listing-profile-right/ListingProfileRight';
// import Gallery from '../../custom-components/elements/gallery/Gallery';
// import ProfileVideo from '../../custom-components/elements/profile-video/ProfileVideo';
// ProfileLanguages, ProfileMeetingTypes, ServiceDeliveryTo moved into PremiumProfileBio program details
import ListingProfileMobile from '../../custom-components/elements/listing-profile-right/ListingProfileMobile';
// import BookingPanel from '../../components/BookingPanel/BookingPanel';
import NewsletterSection from '../../custom-components/elements/newsletter-section/NewsletterSection';

import SkyLight from 'react-skylight';
import BookingModal from '../../custom-components/elements/listing-profile-right/bookingModal/BookingModal';
// import SideChat from '../../custom-components/elements/side-chat/SideChat';
import { addChat } from '../../custom-ducks/socketChat.duck';
import { createFreeCallActivity } from '../../custom-ducks/activities.duck';
import { marketplaceLockupLogo as AppLogo } from '../../assets/viveka-logos';
import MainDashboardWrapper from '../../components/MainDashboardWrapper/MainDashboardWrapper';
import { notifyError } from '../../components/HotToast/HotToastProvider';
import { brandedConfirmAlert } from '../../components/PopupShell/brandedConfirmAlert';

// const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID } = sdkTypes;

// Coaches sometimes store an honorific ("Dr.", "Prof.") as part of their
// display name; taking the literal first token would greet the client with
// "Talk to Dr. first" instead of the coach's actual first name.
const NAME_PREFIXES = ['dr', 'dr.', 'mr', 'mr.', 'mrs', 'mrs.', 'ms', 'ms.', 'prof', 'prof.', 'miss'];
function firstNameFrom(displayName) {
  const parts = (displayName || '').trim().split(/\s+/).filter(Boolean);
  const withoutPrefix = parts.length > 1 && NAME_PREFIXES.includes(parts[0].toLowerCase())
    ? parts.slice(1)
    : parts;
  return withoutPrefix[0] || 'the coach';
}

// Strips markup/entities down to plain, whitespace-collapsed text — used to
// derive the coach card's short bio excerpt from the rich-text bio field.
function stripHtml(html) {
  if (!html) return '';
  return decode(html)
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function truncate(text, maxLen) {
  if (!text || text.length <= maxLen) return text;
  const cut = text.slice(0, maxLen);
  const lastSpace = cut.lastIndexOf(' ');
  return (lastSpace > 40 ? cut.slice(0, lastSpace) : cut).trim() + '…';
}

// const priceData = (price, intl) => {
//   if (price && price.currency === config.currency) {
//     const formattedPrice = formatMoney(intl, price);
//     return { formattedPrice, priceTitle: formattedPrice };
//   } else if (price) {
//     return {
//       formattedPrice: `(${price.currency})`,
//       priceTitle: `Unsupported currency (${price.currency})`,
//     };
//   }
//   return {};
// };

// const categoryLabel = (categories, key) => {
//   const cat = categories.find(c => c.key === key);
//   return cat ? cat.label : key;
// };

export class ListingPageComponent extends Component {
  authorOfTheListing;

  constructor(props) {
    super(props);
    const { enquiryModalOpenForListingId, params } = props;
    this.state = {
      pageClassNames: [],
      imageCarouselOpen: false,
      enquiryModalOpen: enquiryModalOpenForListingId === params.id,
      userOnline: false,
      testimonials: [],
      certifications: [],
      otherListings: [],
    };
    this._fetchTestimonialsFor = null;
    this._fetchCredentialsFor = null;
    this._fetchOtherListingsFor = null;
    this._autoBookTriggered = false;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.maybeTriggerAutoBook = this.maybeTriggerAutoBook.bind(this);
    this.onContactUser = this.onContactUser.bind(this);
    this.onSubmitEnquiry = this.onSubmitEnquiry.bind(this);
    this.setupSocket.bind(this);
  }

  fetchTestimonials(coachId, isOwnListing) {
    if (!coachId || this._fetchTestimonialsFor === coachId) return;
    this._fetchTestimonialsFor = coachId;

    if (isOwnListing) {
      this.props.onFetchMyTestimonials()
        .then(data => {
          const confirmed = ((data && data.testimonials) || []).filter(t => t.status === 'confirmed');
          this.setState({ testimonials: confirmed });
        })
        .catch(() => {});
    } else {
      axios
        .get(`${config.coachSaaSService}testimonials/public/${coachId}?limit=10`)
        .then(res => {
          const list = Array.isArray(res.data) ? res.data : (res.data && res.data.testimonials) || [];
          this.setState({ testimonials: list });
        })
        .catch(() => {});
    }
  }

  fetchCertifications(coachId, isOwnListing) {
    if (!coachId || this._fetchCredentialsFor === coachId) return;
    this._fetchCredentialsFor = coachId;

    if (isOwnListing) {
      this.props.onFetchMyCredentials()
        .then(data => {
          const approved = ((data && data.credentials) || []).filter(c => c.status === 'approved');
          this.setState({ certifications: approved });
        })
        .catch(() => {});
    } else {
      axios
        .get(`${config.coachSaaSService}credentials/public/${coachId}?limit=20`)
        .then(res => {
          const list = (res.data && res.data.credentials) || [];
          this.setState({ certifications: list });
        })
        .catch(() => {});
    }
  }

  // Other published listings by this coach — powers the "More from
  // {coach}" cross-sell card near the bottom of the page.
  fetchOtherListings(coachId) {
    if (!coachId || this._fetchOtherListingsFor === coachId) return;
    this._fetchOtherListingsFor = coachId;

    this.props
      .onFetchAuthorOtherListings(coachId)
      .then(listings => {
        const currentId = this.props.params.id;
        const filtered = (listings || []).filter(l => l.id.uuid !== currentId);
        this.setState({ otherListings: filtered });
      })
      .catch(() => {});
  }

  setupSocket() {
    const { socket } = this.props;
    if (!socket) return;
    socket.emit('userStatus', this.authorOfTheListing.id.uuid);
    socket.on('userStatus', isAvailable => {
      if (isAvailable) {
        this.setState({ userOnline: true });
      } else {
        this.setState({ userOnline: false });
      }
    });
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    // this.setupSocket();
    const { getListing, params, currentUser } = this.props;
    const listing = getListing(new UUID(params.id));
    if (listing && listing.author) {
      const coachId = listing.author.id.uuid;
      const isOwn = !!(currentUser && currentUser.id.uuid === coachId);
      this.fetchTestimonials(coachId, isOwn);
      this.fetchCertifications(coachId, isOwn);
      this.fetchOtherListings(coachId);
    }
    this.maybeTriggerAutoBook();
  }

  componentDidUpdate(prevProps) {
    const { getListing, params, currentUser } = this.props;
    const listing = getListing(new UUID(params.id));
    if (!listing || !listing.author) return;
    const coachId = listing.author.id.uuid;
    const prevCoachId = this._fetchTestimonialsFor;
    const isOwn = !!(currentUser && currentUser.id.uuid === coachId);
    if (coachId !== prevCoachId) {
      this._fetchTestimonialsFor = null;
      this._fetchCredentialsFor = null;
      this._fetchOtherListingsFor = null;
      this.setState({ testimonials: [], certifications: [], otherListings: [] });
      this.fetchTestimonials(coachId, isOwn);
      this.fetchCertifications(coachId, isOwn);
      this.fetchOtherListings(coachId);
    }
    this.maybeTriggerAutoBook();
  }

  /**
   * Coach invite emails link straight to a specific listing with
   * `?autoBook=1` so the invited client lands on checkout instead of
   * having to find and click "Book now" themselves. Mirrors `bookNow` in
   * render: fixed-price listings skip straight to checkout, hourly
   * listings get the quantity-picker modal opened automatically (their
   * price depends on hours picked, so checkout can't be reached without
   * that input) — either way the client doesn't have to hunt for a
   * "Book now" button themselves.
   */
  maybeTriggerAutoBook() {
    if (this._autoBookTriggered) return;

    const { location, getListing, params, currentUser } = this.props;
    const { autoBook } = parse(location.search);
    if (autoBook !== true) return;

    const listing = getListing(new UUID(params.id));
    if (!listing || !listing.id || !listing.attributes) return;

    const isOwnListing = !!(currentUser && listing.author && currentUser.id.uuid === listing.author.id.uuid);
    const isCurrentlyClosed = listing.attributes.state === LISTING_STATE_CLOSED;
    if (isOwnListing || isCurrentlyClosed) return;

    const isHourly = listing.attributes.publicData && listing.attributes.publicData.per === 'hourly';
    if (isHourly) {
      // The modal ref is only set once render() has run at least once with
      // the listing loaded — bail out and retry on the next
      // componentDidUpdate if it isn't there yet.
      if (!this.simpleDialogRef) return;
      this._autoBookTriggered = true;
      this.simpleDialogRef.show();
      return;
    }

    this._autoBookTriggered = true;
    this.handleSubmit({ quantity: 1 });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    var rightColumn = document.querySelector('#right_column');
    var navBarWrapper = document.querySelector('#nav_bar_wrapper');
    if (rightColumn) {
      var rightColumnHeight = rightColumn.getBoundingClientRect().height;
      var rightColumnTop = navBarWrapper.getBoundingClientRect().height;

      var fixedContainer = document.querySelector('#fixed_container');
      if (fixedContainer) {
        var fixedContainerHeight = fixedContainer.getBoundingClientRect().height;
        var fixedContainerTop = window.scrollY - rightColumnTop;

        if (window.outerWidth > 768) {
          if (
            fixedContainerTop < rightColumnHeight - fixedContainerHeight &&
            fixedContainerTop > 0
          ) {
            fixedContainer.style.top = fixedContainerTop + 'px';
          }
        } else {
          document.querySelector('#fixed_container').style.top = 0;
        }
      }
    }
  }

  handleSubmit(values) {
    const {
      history,
      getListing,
      // getAuthor,
      params,
      callSetInitialValues,
      onInitializeCardPaymentData,
    } = this.props;
    const listingId = new UUID(params.id);
    const listing = getListing(listingId);
    // const author = getAuthor(new UUID('5eafb7eb-755e-4c8e-b033-539fe0a99bfc'))

    const { ...bookingData } = values;
    const now = new Date();
    const bookingDates = {
      startDate: new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1)),
      endDate: new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 3)),
    };

    const initialValues = {
      listing,
      bookingData,
      bookingDates: {
        bookingStart: bookingDates.startDate,
        bookingEnd: bookingDates.endDate,
      },
      confirmPaymentError: null,
    };

    const routes = routeConfiguration();
    // Customize checkout page state with current listing and selected bookingDates
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);
    callSetInitialValues(setInitialValues, initialValues);

    // Clear previous Stripe errors from store if there is any
    onInitializeCardPaymentData();

    // Redirect to CheckoutPage
    history.push(
      createResourceLocatorString(
        'CheckoutPage',
        routes,
        { id: listing.id.uuid, slug: createSlug(listing.attributes.title) },
        {}
      )
    );
  }

  onContactUser() {
    const { currentUser, history, callSetInitialValues, params, location } = this.props;

    if (!currentUser) {
      const state = { from: `${location.pathname}${location.search}${location.hash}` };

      // We need to log in before showing the modal, but first we need to ensure
      // that modal does open when user is redirected back to this listingpage
      callSetInitialValues(setInitialValues, { enquiryModalOpenForListingId: params.id });

      // signup and return back to listingPage.
      history.push(
        createResourceLocatorString('SignupPageSteps', routeConfiguration(), {}, {}),
        state
      );
    } else {
      this.setState({ enquiryModalOpen: true });
    }
  }

  onSubmitEnquiry(values, alias) {
    const { history, params, onSendEnquiry } = this.props;
    const routes = routeConfiguration();
    const listingId = new UUID(params.id);
    const { message } = values;

    onSendEnquiry(listingId, message.trim(), alias)
      .then(txId => {
        this.setState({ enquiryModalOpen: false });

        // Redirect to OrderDetailsPage
        history.push(
          createResourceLocatorString('OrderDetailsPage', routes, { id: txId.uuid }, {})
        );
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }

  render() {
    const {
      // unitType,
      isAuthenticated,
      currentUser,
      getListing,
      getOwnListing,
      intl,
      // onManageDisableScrolling,
      params: rawParams,
      location,
      scrollingDisabled,
      showListingError,
      // reviews,
      // fetchReviewsError,
      // sendEnquiryInProgress,
      // sendEnquiryError,
      // timeSlots,
      // fetchTimeSlotsError,
      // categoriesConfig,
      // amenitiesConfig,
      // languageConfig,
    } = this.props;

    const listingId = new UUID(rawParams.id);
    const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
    const currentListing =
      isPendingApprovalVariant || isDraftVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(getListing(listingId));

    // console.log('current listing');
    // console.log(currentListing);

    const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
    const params = { slug: listingSlug, ...rawParams };

    // const listingType = isDraftVariant
    //   ? LISTING_PAGE_PARAM_TYPE_DRAFT
    //   : LISTING_PAGE_PARAM_TYPE_EDIT;
    // const listingTab = isDraftVariant ? 'photos' : 'description';

    const isApproved =
      currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;

    const pendingIsApproved = isPendingApprovalVariant && isApproved;

    // If a /pending-approval URL is shared, the UI requires
    // authentication and attempts to fetch the listing from own
    // listings. This will fail with 403 Forbidden if the author is
    // another user. We use this information to try to fetch the
    // public listing.
    const pendingOtherUsersListing =
      (isPendingApprovalVariant || isDraftVariant) &&
      showListingError &&
      showListingError.status === 403;
    const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

    if (shouldShowPublicListingPage) {
      return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
    }

    const {
      description = '',
      geolocation = null,
      price = null,
      title = '',
      publicData,
    } = currentListing.attributes;

    // console.log('Location');
    // console.log(publicData);

    // const richTitle = (
    //   <span>
    //     {richText(title, {
    //       longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
    //       longWordClass: css.longWord,
    //     })}
    //   </span>
    // );

    // const bookingTitle = (
    //   <FormattedMessage id="ListingPage.bookingTitle" values={{ title: richTitle }} />
    // );
    // const bookingSubTitle = intl.formatMessage({ id: 'ListingPage.bookingSubTitle' });
    //
    // const topbar = <TopbarContainer />;

    if (showListingError && showListingError.status === 404) {
      // 404 listing not found

      return <NotFoundPage />;
    } else if (showListingError) {
      // Other error in fetching listing

      const errorTitle = intl.formatMessage({
        id: 'ListingPage.errorLoadingListingTitle',
      });

      return (
        <PageWrapper title={errorTitle} scrollingDisabled={scrollingDisabled}>
          {/* <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.errorText}>
                <FormattedMessage id="ListingPage.errorLoadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn> */}
        </PageWrapper>
      );
    } else if (!currentListing.id) {
      // Still loading the listing

      const loadingTitle = intl.formatMessage({
        id: 'ListingPage.loadingListingTitle',
      });

      return (
        <PageWrapper title={loadingTitle} scrollingDisabled={scrollingDisabled}>
          {/* <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.loadingText}>
                <FormattedMessage id="ListingPage.loadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn> */}
        </PageWrapper>
      );
    }

    // const handleViewPhotosClick = e => {
    //   // Stop event from bubbling up to prevent image click handler
    //   // trying to open the carousel as well.
    //   e.stopPropagation();
    //   this.setState({
    //     imageCarouselOpen: true,
    //   });
    // };
    const authorAvailable = currentListing && currentListing.author;
    const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
    const isOwnListing =
      userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;
    // const showContactUser = authorAvailable && (!currentUser || (currentUser && !isOwnListing));

    const isPremium =
      currentListing.attributes.metadata.premium && currentListing.attributes.metadata.premium > 0;

    const currentAuthor = authorAvailable ? currentListing.author : null;
    const ensuredAuthor = ensureUser(currentAuthor);
    this.authorOfTheListing = ensuredAuthor;

    const listingLocation = currentListing.attributes.publicData.location.address;

    // When user is banned or deleted the listing is also deleted.
    // Because listing can be never showed with banned or deleted user we don't have to provide
    // banned or deleted display names for the function
    const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');

    const authorUrl =
      currentListing.attributes.publicData.author && ensuredAuthor.id
        ? `/u/${strToSlug(currentListing.attributes.publicData.author)}/${ensuredAuthor.id.uuid}`
        : '';

    // console.log('ensured user');
    // console.log(ensuredAuthor.attributes.profile.publicData);

    const usersPublicData = ensuredAuthor.attributes.profile.publicData;

    // const { formattedPrice } = priceData(price, intl);

    const handleBookingSubmit = values => {
      const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
      if (isOwnListing) {
        brandedConfirmAlert({
          title: 'Self-booking not allowed',
          message:
            "You can't book your own ad. Share this listing's link with a client so they can book it directly.",
          tone: 'warning',
          buttons: [{ label: 'Got it' }],
        });
      } else if (isCurrentlyClosed) {
        brandedConfirmAlert({
          title: 'This ad is closed',
          message: 'This ad is currently closed and not accepting new bookings.',
          tone: 'warning',
          buttons: [{ label: 'Ok' }],
        });
      } else {
        this.handleSubmit(values);
      }
    };

    // const listingImages = (listing, variantName) =>
    //   (listing.images || [])
    //     .map(image => {
    //       const variants = image.attributes.variants;
    //       const variant = variants ? variants[variantName] : null;
    //
    //       // deprecated
    //       // for backwards combatility only
    //       const sizes = image.attributes.sizes;
    //       const size = sizes ? sizes.find(i => i.name === variantName) : null;
    //
    //       return variant || size;
    //     })
    //     .filter(variant => variant != null);

    const currentListingImages =
      currentListing && currentListing.images ? currentListing.images : [];
    // const facebookImages = listingImages(currentListing, 'facebook');
    // const twitterImages = listingImages(currentListing, 'twitter');
    // const schemaImages = JSON.stringify(facebookImages.map(img => img.url));
    // const siteTitle = config.siteTitle;
    // const schemaTitle = intl.formatMessage(
    //   { id: 'ListingPage.schemaTitle' },
    //   { title, price: formattedPrice, siteTitle }
    // );

    // console.log('listing images');
    // console.log(currentListingImages);

    // const hostLink = (
    //   <NamedLink
    //     className={css.authorNameLink}
    //     name="ListingPage"
    //     params={params}
    //     to={{ hash: '#host' }}
    //   >
    //     {authorDisplayName}
    //   </NamedLink>
    // );

    // const category =
    //   publicData && publicData.category ? (
    //     <span>
    //       {categoryLabel(categoriesConfig, publicData.category)}
    //       <span className={css.separator}>•</span>
    //     </span>
    //   ) : null;

    // const isNightly = unitType === LINE_ITEM_NIGHT;
    // const isDaily = unitType === LINE_ITEM_DAY;

    // const unitTranslationKey = isNightly
    //   ? 'ListingPage.perNight'
    //   : isDaily
    //   ? 'ListingPage.perDay'
    //   : 'ListingPage.perUnit';

    // const rateCode = () => {
    //   return injectIntl(<FormattedMessage id={unitTranslationKey} />);
    // };

    // const videos = () => {
    //   let videoElements = [];
    //   if (publicData.videos) {
    //     publicData.videos.map(video => {
    //       videoElements.push(<ProfileVideo url={video} />);
    //     });
    //   }
    //   return videoElements;
    // };

    let simpleDialog;

    const bookNow = () => {
      // console.log(currentListing);
      const isHourly =
        currentListing.attributes.publicData &&
        currentListing.attributes.publicData.per === 'hourly';
      if (isOwnListing) {
        handleBookingSubmit({ quantity: 1, currentListing });
        return;
      }
      if (isHourly) {
        simpleDialog.show();
      } else {
        handleBookingSubmit({ quantity: 1, currentListing });
      }
    };

    const modelStyle = {
      width: 'min(440px, calc(100vw - 40px))',
      minHeight: 'auto',
      top: '50%',
      left: '50%',
      marginTop: '-230px',
      marginLeft: 'calc(-1 * min(220px, calc(50vw - 20px)))',
      padding: 0,
      borderRadius: '20px',
      overflow: 'hidden',
      backgroundColor: '#fff',
      boxShadow: '0 25px 60px -12px rgba(20, 184, 166, 0.35), 0 0 0 1px rgba(20, 184, 166, 0.08)',
      maxHeight: '90vh',
      overflowY: 'auto',
    };

    const modelOverlayStyle = {
      backgroundColor: 'rgba(15, 23, 42, 0.55)',
      backdropFilter: 'blur(6px)',
      WebkitBackdropFilter: 'blur(6px)',
    };

    const facebook = usersPublicData && usersPublicData.facebook ? usersPublicData.facebook : '';
    const linkedin = usersPublicData && usersPublicData.linkedin ? usersPublicData.linkedin : '';
    const twitter = usersPublicData && usersPublicData.twitter ? usersPublicData.twitter : '';
    const youtube = usersPublicData && usersPublicData.youtube ? usersPublicData.youtube : '';

    const rate_type =
      currentListing && currentListing.attributes.publicData.per === 'hourly' ? 'hour' : 'package';

    const PageTitle = currentListing && currentListing.attributes.title;
    const pageImage =
      currentListingImages && currentListingImages[0].attributes.variants['landscape-crop2x'].url;
    const pageDescription =
      currentListing && currentListing.attributes.description.substring(0, 250);
    const keywords = currentListing.attributes.publicData['type-of-service'];

    const authorId = ensuredAuthor && ensuredAuthor.id.uuid;
    const contactNow = () => {
      if (isAuthenticated) {
        if (authorId !== currentUser.id.uuid) {
          this.props.onContactNow({
            name: authorDisplayName,
            userId: authorId,
            isOpened: true,
            isOnline: false,
            messages: [],
          });
        }
      } else {
        notifyError('Login before contacting')
      }
    };

    const talkToCoachFirst = () => {
      if (isOwnListing) {
        brandedConfirmAlert({
          title: 'Self-booking not allowed',
          message: "You can't request a free intro call on your own ad.",
          tone: 'warning',
          buttons: [{ label: 'Got it' }],
        });
        return;
      }
      if (window.confirm('Are you sure you want to request a free introduction call?')) {
        this.props.onCreateFreeCallActivity(currentListing.id.uuid).then(res => {
          this.props.history.push(`/v-coach/client/my-activities/${res.data.id}`);
        });
      }
    };

    const filteredServiceTags = (currentListing.attributes.publicData['type-of-service'] || []).filter(
      Boolean
    );
    const firstName = firstNameFrom(authorDisplayName);
    const bioPlain = stripHtml(description);

    // readPublicBadgeTier only reads the stored publicData.coachTier field
    // (written by an admin/scheduled job) — a coach who's never been graded
    // reads as Network Member (no badge) even if they objectively meet the
    // Verified bar. This page already has the coach's live testimonials and
    // credentials counts loaded, so fall back to computing Verified from
    // those same thresholds when no stored tier exists, rather than hiding
    // a badge a real coach has actually earned.
    const storedCoachTier = ensuredAuthor ? readPublicBadgeTier(ensuredAuthor) : null;
    const meetsVerifiedByActivity =
      this.state.testimonials.length >= MIN_VERIFIED_TESTIMONIALS &&
      this.state.certifications.length >= MIN_VERIFIED_CERTIFICATIONS;
    const coachTier =
      storedCoachTier && storedCoachTier !== TIERS.NETWORK_MEMBER
        ? storedCoachTier
        : meetsVerifiedByActivity
        ? TIERS.VERIFIED
        : storedCoachTier;
    const coachTierMeta = coachTier ? TIER_META[coachTier] : null;

    const outcomes = Array.isArray(publicData.outcomes) ? publicData.outcomes.filter(Boolean) : [];
    const walkAwayItems = Array.isArray(publicData.walkAwayItems)
      ? publicData.walkAwayItems.filter(item => item && item.title)
      : [];
    const itinerary = Array.isArray(publicData.itinerary)
      ? publicData.itinerary.filter(item => item && item.title)
      : [];
    const inclusions = Array.isArray(publicData.inclusions) ? publicData.inclusions.filter(Boolean) : [];

    const durationLabel =
      publicData.durationLabel ||
      (itinerary.length ? `${itinerary.length} day${itinerary.length !== 1 ? 's' : ''}` : '');
    const eventDates = publicData['event-dates'] || '';
    const format = (publicData['meeting-type'] || []).filter(Boolean)[0] || '';
    const locationShort = listingLocation
      ? listingLocation
          .split(',')
          .slice(0, 2)
          .join(',')
          .trim()
      : '';

    const yearsExperience = usersPublicData && usersPublicData.yearsExperience;
    const topCredential = this.state.certifications[0];
    const totalServicesCount = this.state.otherListings.length + 1;

    const coachStats = [
      yearsExperience ? { value: `${yearsExperience}+ yrs`, label: 'In practice' } : null,
      topCredential
        ? {
            value: topCredential.title,
            label: (topCredential.issuingOrg || topCredential.organization)
              ? `${topCredential.issuingOrg || topCredential.organization} · verified`
              : 'Verified',
          }
        : null,
      this.state.testimonials.length
        ? {
            value: String(this.state.testimonials.length),
            label: `Verified testimonial${this.state.testimonials.length !== 1 ? 's' : ''}`,
          }
        : null,
      {
        value: String(totalServicesCount),
        label: `Service${totalServicesCount !== 1 ? 's' : ''} on Viveka`,
      },
    ].filter(Boolean);

    const rateAmount = convertMoneyToNumber(price);

    const listingContent = (
      <>
        <SkyLight
          hideOnOverlayClicked
          ref={ref => {
            simpleDialog = ref;
            // Also stashed on the instance so maybeTriggerAutoBook (called
            // from componentDidMount/componentDidUpdate, outside this
            // render's closure) can open it for hourly listings.
            this.simpleDialogRef = ref;
          }}
          className={css.model}
          dialogStyles={modelStyle}
          overlayStyles={modelOverlayStyle}
          closeButtonStyle={{ display: 'none' }}
        >
          <BookingModal
            currentListing={currentListing}
            handleBookingSubmit={handleBookingSubmit}
            onClose={() => simpleDialog.hide()}
          />
        </SkyLight>
        <div className={css.root}>
          <div className={css.listing_outer}>
            <div className={css.page_content_inner}>
                <PremiumProfileBio
                  services={currentListing.attributes.publicData['type-of-service']}
                  title={title}
                  bio={description}
                  authorName={authorDisplayName}
                  language={currentListing.attributes.publicData.language}
                  location={listingLocation}
                  sessions={publicData.sessions || 6}
                  durationLabel={durationLabel}
                  user={ensuredAuthor}
                  authorUrl={authorUrl}
                  heroHighlights={outcomes}
                  coachTier={coachTier}
                  listingId={currentListing.id && currentListing.id.uuid}
                  rightSlot={
                    <ListingProfileRight
                      title={title}
                      name={authorDisplayName}
                      isPremium={isPremium}
                      images={currentListingImages}
                      user={ensuredAuthor}
                      rate={rateAmount}
                      durationSummary={durationLabel}
                      sessions={publicData.sessions || 6}
                      format={format}
                      locationShort={locationShort}
                      eventDates={eventDates}
                      location={listingLocation}
                      handleBookingSubmit={handleBookingSubmit}
                      currentListing={currentListing}
                      isOwnListing={isOwnListing}
                      onSubmitEnquiry={this.onSubmitEnquiry}
                      onTalkFirst={talkToCoachFirst}
                      rate_type={rate_type}
                      isOnline={this.state.userOnline}
                      history={this.props.history}
                    />
                  }
                />

                <div className={css.mobile_booking_container}>
                  <ListingProfileMobile
                    isPremium={isPremium}
                    rate={convertMoneyToNumber(price)}
                    name={authorDisplayName}
                    user={ensuredAuthor}
                    onBooknow={bookNow}
                    onContactNow={contactNow}
                  />
                </div>

                {walkAwayItems.length > 0 && (
                  <div id="walkaway-section" className={css.walkAwaySection}>
                    <h2 className={css.bigSectionTitleUnderlined}>What you'll walk away with</h2>
                    <div className={css.walkAwayGrid}>
                      {walkAwayItems.map((item, i) => (
                        <div key={i} className={css.walkAwayCard}>
                          <h3 className={css.walkAwayCardTitle}>{item.title}</h3>
                          {item.description && (
                            <p className={css.walkAwayCardDesc}>{item.description}</p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {itinerary.length > 0 && (
                  <div id="itinerary-section" className={css.itinerarySection}>
                    <div className={css.itineraryHeader}>
                      <h2 className={css.bigSectionTitle}>What you'll experience</h2>
                      <span className={css.itinerarySubtitle}>
                        Structure makes an expensive service tangible
                      </span>
                    </div>
                    <div className={css.itineraryGrid}>
                      {itinerary.map((day, i) => (
                        <div key={i} className={css.itineraryCol}>
                          <span className={css.itineraryDayLabel}>{day.day || `Day ${i + 1}`}</span>
                          <h3 className={css.itineraryColTitle}>{day.title}</h3>
                          {day.description && (
                            <p className={css.itineraryColDesc}>{day.description}</p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {inclusions.length > 0 && (
                  <div className={css.inclusionsSection}>
                    <h2 className={css.bigSectionTitle}>What's included</h2>
                    <div className={css.inclusionsGrid}>
                      {inclusions.map((inc, i) => (
                        <div key={i} className={css.inclusionItem}>
                          <FontAwesomeIcon icon={faCheckCircle} className={css.inclusionIcon} />
                          <span>{inc}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className={css.coach_location_section}>
                  <h2 className={css.section_title}>
                    <FormattedMessage id="ListingPage.locationTitle" />
                  </h2>
                  <div className={css.section_map}>
                    <SectionMapMaybe
                      zoom={5}
                      geolocation={geolocation}
                      publicData={publicData}
                      listingId={currentListing.id}
                    />
                  </div>
                </div>

                <div id="coach-section" className={css.itineraryHeader}>
                  <h2 className={css.bigSectionTitle}>Your coach</h2>
                  <span className={css.itinerarySubtitle}>
                    No dead ends — proof travels with the offer
                  </span>
                </div>
                <div className={css.coachCard}>
                  <div className={css.coachCardHeader}>
                    <div className={css.coachCardAvatarWrap}>
                      {authorUrl ? (
                        <Link to={authorUrl}>
                          <AvatarLarge
                            disableProfileLink
                            user={ensuredAuthor}
                            className={css.coachCardAvatar}
                          />
                        </Link>
                      ) : (
                        <AvatarLarge
                          disableProfileLink
                          user={ensuredAuthor}
                          className={css.coachCardAvatar}
                        />
                      )}
                    </div>
                    <div className={css.coachCardInfo}>
                      {coachTierMeta && coachTierMeta.showBadge && (
                        <span className={css.coachCardBadge}>
                          <TierBadge tier={coachTier} size="sm" showLabel />
                        </span>
                      )}
                      <h3 className={css.coachCardName}>
                        {authorUrl ? (
                          <Link to={authorUrl}>{authorDisplayName}</Link>
                        ) : (
                          authorDisplayName
                        )}
                      </h3>
                      {filteredServiceTags.length > 0 && (
                        <p className={css.coachCardSpecialties}>
                          {filteredServiceTags.map(s => s.toUpperCase()).join(' · ')}
                        </p>
                      )}
                    </div>
                  </div>

                  {bioPlain && <p className={css.coachCardBio}>{truncate(bioPlain, 320)}</p>}

                  {coachStats.length > 0 && (
                    <div className={css.coachStatsRow}>
                      {coachStats.map((stat, i) => (
                        <div key={i} className={css.coachStat}>
                          <p className={css.coachStatValue}>{stat.value}</p>
                          <p className={css.coachStatLabel}>{stat.label}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  {authorUrl && (
                    <Link to={authorUrl} className={css.coachCardLink}>
                      View full profile →
                    </Link>
                  )}
                </div>

                {this.state.certifications.length > 0 && (
                  <div id="credentials-section" className={css.coach_location_section}>
                    <h2 className={css.section_title}>
                      <FontAwesomeIcon icon={faGraduationCap} style={{ marginRight: 10, color: '#0d4f3c' }} />
                      Credentials &amp; Experience
                    </h2>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '16px' }}>
                      {this.state.certifications.map((c, i) => (
                        <div key={c.id || i} style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '16px 18px' }}>
                          <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#0d4f3c', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18"><circle cx="12" cy="8" r="7"/><path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12"/></svg>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 600, fontSize: 14, color: '#1e293b' }}>{c.title}</div>
                            {(c.issuingOrg || c.issuedYear) && (
                              <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                                {[c.issuingOrg, c.issuedYear].filter(Boolean).join(' · ')}
                              </div>
                            )}
                            {c.fileUrl && (
                              <a href={c.fileUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: '#0d9488', marginTop: 4, display: 'inline-block' }}>
                                View certificate ↗
                              </a>
                            )}
                          </div>
                          <span style={{ fontSize: 11, fontWeight: 600, color: '#0d9488', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 20, padding: '2px 10px', whiteSpace: 'nowrap' }}>✓ Verified</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {this.state.testimonials.length > 0 && (
                  <div id="reviews-section" className={css.testimonialsSection}>
                    <div className={css.itineraryHeader}>
                      <h2 className={css.bigSectionTitle}>
                        <FontAwesomeIcon icon={faQuoteLeft} style={{ marginRight: 10, color: '#0d4f3c' }} />
                        From {firstName}'s clients
                      </h2>
                      <span className={css.itinerarySubtitle}>
                        Testimonials filtered to this service's category
                      </span>
                    </div>
                    <div className={css.testimonialsGrid}>
                      {this.state.testimonials.slice(0, 6).map((t, i) => {
                        const name = t.refereeName || 'Client';
                        const date = (t.confirmedAt || t.submittedAt)
                          ? new Date(t.confirmedAt || t.submittedAt).toLocaleDateString('en-US', {
                              month: 'short',
                              year: 'numeric',
                            })
                          : '';
                        const org = [t.refereeTitle || t.refereeOrg, date].filter(Boolean).join(' · ');
                        const initials = name.trim().split(/\s+/).length >= 2
                          ? (name.trim().split(/\s+/)[0][0] + name.trim().split(/\s+/).slice(-1)[0][0]).toUpperCase()
                          : name.slice(0, 2).toUpperCase();
                        return (
                          <div key={t.id || i} className={css.testimonialCard}>
                            {t.body && <p className={css.testimonialQuote}>&ldquo;{t.body}&rdquo;</p>}
                            <div className={css.testimonialFooter}>
                              <div className={css.testimonialAvatar}>{initials}</div>
                              <div className={css.testimonialMeta}>
                                <div className={css.testimonialName}>{name}</div>
                                {org && <div className={css.testimonialOrg}>{org}</div>}
                              </div>
                              <span className={css.testimonialVerified}>✓ Verified</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                <div className={css.readyBar}>
                  <h2 className={css.readyTitle}>Ready to begin?</h2>
                  <div className={css.readyColumns}>
                    <div className={css.readyCol}>
                      <span className={css.readyLabel}>Price</span>
                      <span className={css.readyValue}>
                        {rateAmount != null ? `$${rateAmount.toLocaleString()}` : '—'} per {rate_type}
                      </span>
                    </div>
                    {durationLabel && (
                      <div className={css.readyCol}>
                        <span className={css.readyLabel}>Duration</span>
                        <span className={css.readyValue}>{durationLabel}</span>
                      </div>
                    )}
                    {format && (
                      <div className={css.readyCol}>
                        <span className={css.readyLabel}>Format</span>
                        <span className={css.readyValue}>{format}</span>
                      </div>
                    )}
                    {locationShort && (
                      <div className={css.readyCol}>
                        <span className={css.readyLabel}>Location</span>
                        <span className={css.readyValue}>{locationShort}</span>
                      </div>
                    )}
                    {eventDates && (
                      <div className={css.readyCol}>
                        <span className={css.readyLabel}>Next dates</span>
                        <span className={css.readyValue}>{eventDates}</span>
                      </div>
                    )}
                  </div>
                  <div className={css.readyActions}>
                    <button type="button" className={css.readyPrimaryBtn} onClick={bookNow}>
                      Book this experience
                    </button>
                    <button type="button" className={css.readySecondaryBtn} onClick={talkToCoachFirst}>
                      Schedule intro call
                    </button>
                  </div>
                  <p className={css.readyFootnote}>
                    <FontAwesomeIcon icon={faCheckCircle} className={css.readyFootnoteIcon} />
                    Free cancellation within 24 hours of booking ·{' '}
                    <a
                      href="https://viveka.world/terms-of-service"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={css.readyFootnoteLink}
                    >
                      Cancellation &amp; refund terms
                    </a>
                  </p>
                </div>

                {this.state.otherListings.length > 0 &&
                  (() => {
                    const other = this.state.otherListings[0];
                    const oTitle = other.attributes.title || '';
                    const oPrice = other.attributes.price ? convertMoneyToNumber(other.attributes.price) : null;
                    const isFree = oPrice === 0;
                    const oImage =
                      other.images &&
                      other.images[0] &&
                      other.images[0].attributes.variants['landscape-crop']
                        ? other.images[0].attributes.variants['landscape-crop'].url
                        : null;
                    const oUrl = `/l/${strToSlug(oTitle)}/${other.id.uuid}`;
                    return (
                      <div className={css.coach_location_section}>
                        <h2 className={css.section_title}>More from {firstName}</h2>
                        <Link to={oUrl} className={css.crossSellCard}>
                          {oImage && (
                            <img src={oImage} alt={oTitle} className={css.crossSellImage} />
                          )}
                          <div className={css.crossSellBody}>
                            <p className={css.crossSellTitle}>{oTitle}</p>
                            {this.state.testimonials.length > 0 && (
                              <p className={css.crossSellMeta}>
                                {this.state.testimonials.length} verified testimonial
                                {this.state.testimonials.length !== 1 ? 's' : ''} · {totalServicesCount}{' '}
                                services available
                              </p>
                            )}
                            <span className={css.crossSellPrice}>
                              {isFree ? 'Free' : oPrice != null ? `$${oPrice.toLocaleString()}` : ''}
                            </span>
                          </div>
                          <span className={css.crossSellCta}>
                            {isFree ? 'Choose a time' : 'View experience'} →
                          </span>
                        </Link>
                      </div>
                    );
                  })()}

                <NewsletterSection currentUser={currentUser} />
            </div>
          </div>
        </div>
      </>
    );

    return (
      <PageWrapper
        title={`${PageTitle} | Viveka`}
        image={pageImage}
        className={css.page_wrapper}
        description={pageDescription}
        keywords={keywords}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ItemPage',
          description: pageDescription,
          name: PageTitle,
          image: [pageImage],
        }}
        isSocketConnectable={true}
      >
        {isAuthenticated ? (
          <MainDashboardWrapper page="" title={PageTitle} hideTitleOnMobile>
            <div>{listingContent}</div>
          </MainDashboardWrapper>
        ) : (
          <div className={css.publicWrapper}>
            <nav className={css.publicNavBar}>
              <a href="/s">
                <img src={AppLogo} alt="Viveka" className={css.publicNavLogo} />
              </a>
              <div className={css.publicNavActions}>
                <a href="/login" className={css.publicLoginBtn}>Login</a>
                <a href="/signup/type" className={css.publicSignupBtn}>Sign Up</a>
              </div>
            </nav>
            {listingContent}
          </div>
        )}
      </PageWrapper>
    );
  }
}

ListingPageComponent.defaultProps = {
  unitType: config.bookingUnitType,
  currentUser: null,
  enquiryModalOpenForListingId: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  sendEnquiryError: null,
  categoriesConfig: config.custom.categories,
  amenitiesConfig: config.custom.amenities,
  languageConfig: config.custom.languages,
};

ListingPageComponent.propTypes = {
  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string,
  }).isRequired,

  unitType: propTypes.bookingUnitType,
  // from injectIntl
  intl: intlShape.isRequired,

  params: shape({
    id: string.isRequired,
    slug: string,
    variant: oneOf([LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
  }).isRequired,

  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  getOwnListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  enquiryModalOpenForListingId: string,
  showListingError: propTypes.error,
  callSetInitialValues: func.isRequired,
  reviews: arrayOf(propTypes.review),
  fetchReviewsError: propTypes.error,
  timeSlots: arrayOf(propTypes.timeSlot),
  fetchTimeSlotsError: propTypes.error,
  sendEnquiryInProgress: bool.isRequired,
  sendEnquiryError: propTypes.error,
  onSendEnquiry: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,

  categoriesConfig: array,
  amenitiesConfig: array,
  languageConfig: array,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    enquiryModalOpenForListingId,
  } = state.ListingPage;
  const { currentUser } = state.user;
  const { socket } = state.socket;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getAuthor = id => {
    const ref = { id, type: 'user' };
    const author = getMarketplaceEntities(state, [ref]);
    return author.length === 1 ? author[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getAuthor,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    enquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    socket,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values) => dispatch(setInitialValues(values)),
  onSendEnquiry: (listingId, message, alias) => dispatch(sendEnquiry(listingId, message, alias)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),

  onContactNow: data => dispatch(addChat(data)),
  onFetchMyTestimonials: () => dispatch(fetchMyTestimonials()),
  onFetchMyCredentials: () => dispatch(fetchMyCredentials()),
  onFetchAuthorOtherListings: authorId => dispatch(fetchAuthorOtherListings(authorId)),
  onCreateFreeCallActivity: listingId => dispatch(createFreeCallActivity(listingId)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(ListingPageComponent);

ListingPage.setInitialValues = initialValues => setInitialValues(initialValues);
ListingPage.loadData = loadData;

export default ListingPage;
